import React, { PropsWithChildren } from "react";
import './SlideUpContent.scss';

interface SlideUpContentProps extends PropsWithChildren {
}

interface SlideUpContentState {
}

class SlideUpContent extends React.Component<SlideUpContentProps, SlideUpContentState>{

    render() {
        return (
            <div className="slide-up-content">
                {this.props.children}
            </div>
        );
    }
}

export default SlideUpContent;
